/* eslint-disable import/no-webpack-loader-syntax */
import React from 'react';
import { Editor } from '@tinymce/tinymce-react';

// TinyMCE so the global var exists
// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import tinymce from 'tinymce/tinymce';
// DOM model
import 'tinymce/models/dom/model';
// Theme
import 'tinymce/themes/silver';
// Toolbar icons
import 'tinymce/icons/default';

// importing the plugin js.
// if you use a plugin that is not listed here the editor will fail to load
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/help';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';

export default function BundledEditor(props) {
  const { init, ...rest } = props;
  return (
    <Editor
      init={{
        content_css: false,
        ...init,
        language: window.appState.lang,
        skin_url: `${window.appState.baseStaticUrl}tinymce/retino-skin`,
        language_url: `${window.appState.baseStaticUrl}tinymce/langs/${window.appState.lang}.js`,
        base_url: `${window.appState.baseStaticUrl}dist/tinymce`,
      }}
      {...rest}
    />
  );
}
